<template>
	<div class="flex flex-col items-center gap-12">
		<div class="flex flex-col items-center gap-4">
			<AtomTitle
				tag="h2"
				size="xl"
			>
				Kom vandaag in beweging
			</AtomTitle>
			<p class="text-functional-size-lg text-gray-700">
				Hier begint het.
			</p>
		</div>
		<div class="flex flex-col md:flex-row items-center justify-center gap-8">
			<AtomButton
				size="xl"
				text="Informatie aanvragen"
				:variant="ButtonVariant.Green"
				icon-left="fa-envelope"
				:to="{ url: '#aanmelden', title: 'SGT informatie aanvragen' }"
				@click="trackButtonClick('Sgt1_CTA_Lead')"
			/>
			<AtomButton
				size="xl"
				text="Doe een keer gratis mee"
				icon-left="fa-bolt"
				:to="{ title: 'Aanmelden voor een Small Group Training proefles', url: '/small-group-training/aanmelden-proefles' }"
				@click="trackButtonClick('Sgt1_CTA_Trial')"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';

const { trackButtonClick } = useEventTracking();
</script>
